import { VMContentItem, VMContentResponseItem, VMTipsResponseItem } from "../vm_models";

export class VMContentMapper {
  public static calculateVMContentItems(contentItems: Array<VMContentResponseItem>) : Array<VMContentItem> {
    let vmContentResponse = new Array<VMContentItem>;

    if (contentItems) {
      contentItems.forEach((item) => {
        vmContentResponse.push(this.mapContentItem(item));
      })
    }

    return vmContentResponse;
  }

  public static calculateVMContentItemsTips(tips: VMTipsResponseItem) : Array<VMContentItem> {
    let vmContentResponse = new Array<VMContentItem>;

    if (tips && tips.children) {
      tips.children.forEach((tip) => {
        tip.children.forEach((item) => {
          vmContentResponse.push(this.mapContentItem(item));
        })
      })
    }

    return vmContentResponse;
  }

  public static mapContentItem(item : VMContentResponseItem) : VMContentItem {
    let vmContentItem = new VMContentItem;
        
    vmContentItem.id = item.id;
    vmContentItem.title = item.title?.value ? item.title?.value : '[not set]';
    vmContentItem.content = item.content?.value ? item.content?.value : '[not set]';
    vmContentItem.titleShort = item.titleShort?.value ? item.titleShort?.value : vmContentItem.title;
    vmContentItem.contentShort = item.contentShort?.value ? item.contentShort?.value : '[not set]';

    return vmContentItem;
  }
}